module.exports = __webpack_public_path__ + "static/img/ic_serviceflow_f.6af8cbc1.png";